import { Component, OnInit, OnDestroy } from "@angular/core";
import { ApsService } from "src/app/services/aps.service";
import { Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { NewCardDialogComponent } from "src/app/pages/aps";
import { NewBankDialogComponent } from "src/app/pages/aps";

import { APSMaster, BankInfo, CreditCardInfo } from "src/app/models";
import { NewPaymentMethodDialogComponent } from "../new-payment-method-dialog/new-payment-method-dialog.component";
import { CompanyService } from "src/app/services";

@Component({
  selector: "app-payment-method-list",
  templateUrl: "./payment-method-list.component.html",
  styleUrls: ["./payment-method-list.component.scss"]
})
export class PaymentMethodListComponent implements OnInit, OnDestroy
{

  private availableBanksSubscription: Subscription;
  public availableBanks: APSMaster[];

  private availableCardsSubscription: Subscription;
  public availableCards: APSMaster[];

  constructor(
    private apsService: ApsService,
    private companyService: CompanyService,
    public dialog: MatDialog
  )
  {

  }

  ngOnInit(): void
  {
    this.availableBanksSubscription = this.apsService.availableBanks.subscribe(banks =>
    {
      this.availableBanks = banks;
    });

    this.availableCardsSubscription = this.apsService.availableCards.subscribe(cards =>
    {
      this.availableCards = cards;
    });
  }

  ngOnDestroy(): void
  {
    this.availableBanksSubscription.unsubscribe();
    this.availableCardsSubscription.unsubscribe();
  }

  public handleAddNewPaymentMethod(): void
  {
    const options = {
      panelClass: "form-field-less-than-180",
      width: "400px",
      data: {}
    };
    this.dialog.open(NewPaymentMethodDialogComponent, options).afterClosed().subscribe(e =>
    {
      if (e)
      {
        if (e === "card")
        {
          this.handleAddNewCard();
        } 
        else if (e === "bank")
        {
          this.handleAddNewBank();
        }
      }
    });
  }

  isAutoPayAvailableAndNoPaymentMethod(): boolean
  {
    return this.companyService.isAutopayAvailable && !(this.availableBanks.length > 0 || this.availableCards.length > 0)
  }
  private handleAddNewCard(): void
  {
    const options = {
      panelClass: "form-field-less-than-180",
      width: "400px",
      data: {},
      disableClose: true,
    };

    this.dialog.open(NewCardDialogComponent, options);
  }

  private handleAddNewBank(): void
  {
    const options = {
      panelClass: "form-field-less-than-180",
      width: "800px",
      data: {},
      disableClose: true
    };

    this.dialog.open(NewBankDialogComponent, options);
  }

}
